import { AddEditAlertMessageRequest, deleteAlertMessageRequest, fetchAlertMessageRequest } from '@cbgms/api/modules/customers/requests'
import { AsyncAction } from '@cbgms/base/redux/async-action'
import * as types from './types'

interface AlertMessage {
  AlertMessageUUID: string
  Name: string
  AppId: string | number
  Text: string
  ValidFrom: string
  ValidTo: string
  CreatedBy: string
  CreatedAt: string
  CriteriaUse: boolean
  Link: string
  Criteria: Array<{
    CriteriaId: number
    Name: string
    Value: string
    Comparison: string
  }>
}

export interface DeleteAlertMessageResponse {
  Data: {
    Status: string
    Message: string
  }
}
interface AddAlertMessageResponse {
  Data: {
    Status: string
    Message: string
  }
}
interface AlertMessageResponse {
  Data: AlertMessage[]
}

export const FetchAlertMessage = (status: string, appId: string) => {
  return AsyncAction<AlertMessageResponse>({
    type: [types.FETCH_ALERT_MESSAGE, types.FETCH_ALERT_MESSAGE_SUCCESS, types.FETCH_ALERT_MESSAGE_FAILED],
    payload: {
      api: 'support',
      request: fetchAlertMessageRequest(appId, status)
    }
  })
}

export const DeleteAlertMessage = (messeseId: string) => {
  return AsyncAction<DeleteAlertMessageResponse>({
    type: [types.FETCH_DELETE_ALERT_MESSAGE, types.FETCH_DELETE_ALERT_MESSAGE_SUCCESS, types.FETCH_DELETE_ALERT_MESSAGE_FAILED],
    payload: {
      api: 'support',
      request: deleteAlertMessageRequest(messeseId)
    }
  })
}

export const AddEditAlertMessage = (alertMessageData: AlertMessage) => {
  return AsyncAction<AddAlertMessageResponse>({
    type: [types.FETCH_ADD_ALERT_MESSAGE, types.FETCH_ADD_ALERT_MESSAGE_SUCCESS, types.FETCH_ADD_ALERT_MESSAGE_FAILED],
    payload: {
      api: 'support',

      request: AddEditAlertMessageRequest(alertMessageData)
    }
  })
}
